export default {
	common: {
		close: "Close",
	},
	checkout: {
		steps: {
			cart: "Cart",
			addresses: "Addresses",
			delivery: "Delivery",
			offer: "Offer",
		},
		back: "Back",
		next: "Next",
		cartWarning: {
			line1: "Some items in this cart are currently being blexonised, have not yet been blexonised with the latest version, or their price has changed and has not yet been recalculated.",
			line2: "Please recalculate the items or contact our helpdesk if you have any questions.",
		},
		deliveryAddressTitle: "Delivery address",
		invoiceAddressTitle: "Invoice address",
		moreAddresses: "More addresses...",
		paymentType: {
			title: "Payment method",
			text: "We will send you an invoice {method} to {email}.",
			digitalMethod: "electronically",
			postalMethod: "by post",
			changeAddressTooltip: "Navigates to the address settings.",
			changeAddress: "Change address",
		},
		orderNumberCard: {
			title: "Order number",
			description: "You can assign your own order number for this order.",
			description2: "We will mention this number on the delivery note and the invoice.",
			placeholder: "Your order number",
		},
		notificationsCard: {
			title: "Notifications",
			description:
				"We send the order confirmation and the notification about the completion of your order to your e-mail address ({email}). Optionally, these messages can be sent to an additional e-mail address. A default value for this e-mail can be defined in the {link}.",
			settingsLink: "customer account settings",
			additionalEmailCheckbox: "Send messages to an additional address",
			additionalEmailPlaceholder: "E-mail address",
		},
		addressPicker: {
			title: "Select address for order",
		},
	},
	offer: {
		pleaseSelect: "Please select",
		currentlyUnavailable: "Currently unavailable",
		fastDelivery: "Fast delivery",
		bestPrice: "Best price",
		downloadPdfTooltip: "Download offer as PDF document",
		table: {
			position: "Item",
			price: "Price",
			deliveryDate: "Delivery date (ex works)",
			noDatesAvailable: "No delivery dates available",
			positionsInCartPlural: "{count} items in cart",
			positionsInCartSingular: "Item in cart",
			orderDiscount: "Order discount",
			packagingAndDelivery: "Packaging & delivery {type}",
			accordingToEffort: "based on effort",
			invoiceByPost: "Invoice by post",
			net: "Net",
			vat: "VAT ({ratio}%)",
			total: "Total (incl. VAT)",
		},
		acceptNachAufwand:
			"I am aware that additional costs for packaging & delivery will be incurred",
		acceptAgb: "I agree to the {agb}",
		buyNowTooltip: "Place a binding, chargeable order for this offer",
		buyNow: "Buy now",
		requestOrderTooltip:
			"The order will be forwarded to the responsible person in your organisation for approval.",
		requestOrder: "Request order",
		errors: {
			timerExpired: "The offer timer has expired",
			offerInvalid:
				"The offer is no longer valid because an item in the cart was updated. Please recalculate the offer.",
			agbNotAccepted: "The terms and conditions must be accepted",
			nachAufwandNotAccepted: "The delivery costs based on effort must be accepted",
			noDeliveryDate: "A delivery date must be selected",
			manufacturerNotAvailable:
				"This offer is not available for ramp collection at the selected location. Please select a different collection or delivery location.",
		},
		or: "or",
		emailOrderTooltip:
			"Use this option if you prefer to order by e-mail (e.g. from an ERP/SAP system).",
		emailOrder: "Save offer (order by e-mail)",
		emailOrderHint:
			"The offer is downloaded as a PDF document. To place an order, please send us the PDF document by e-mail, for example as an attachment to an ERP/SAP order.",
		discountDialog: {
			title: "When do I receive an order discount?",
			intro: "When an offer is calculated, all items it contains are taken into account and an order discount is calculated.",
			factorsIntro: "The following factors lead to a {reduction}",
			priceReduction: "price reduction:",
			factor1: "Several items made from the same raw material (same material and same sheet thickness)",
			factor2: "Several items with the same processing (threads, countersinks and extrusions) in the same raw material",
			factor3: "Several items with the same powder coating (same powder)",
			factor4: "Several items with the same galvanisation",
		},
		nachAufwandDialog: {
			title: "Transport based on effort",
			text1: "Where possible, we automatically calculate the costs for packaging and shipping by post or truck.",
			text1b: "We deliberately avoid oversized shipments by post, as the packaging effort for this type of shipment is usually disproportionately high.",
			text1c: "Large and/or heavy parts are delivered by truck. In this case, automatic calculation in advance is not always possible.",
			text2: "The price depends on the packaging effort, the distance to the delivery location, the weight of the parts, and the dimensions of all parts in the entire delivery.",
			text2b: "For large parts (larger than a Euro pallet), the dimensions have a significant impact on the price. Delivery becomes more expensive with every additional centimetre. At the same time, it is very difficult to automatically calculate how bent parts can be stacked and what packaging is required to ensure safe transport.",
			text3Bold:
				"For deliveries based on effort, we therefore charge you the actual amount charged by our carrier according to the ASTAG tariff. In addition, we calculate the time required for packaging to the exact minute.",
			text3: "You can assume that a delivery by truck based on effort typically costs between {currency} 100 and 200.",
			text3b: "For very large shipments, e.g. several Euro pallets or large-area shipments (length x width > 200cm x 100cm), the price may be higher. If in doubt, please contact our helpdesk at {email}",
			text4: "We are aware that it is important for our customers to know the final price, including all costs, before placing an order. Technical limitations currently make this impossible in certain cases. We have deliberately decided against a flat rate, as we are convinced that this approach offers a more transparent and cost-efficient solution that reflects reality.",
		},
		orderFailedDialog: {
			title: "Order failed",
			text: "An error occurred during the ordering process.",
			text2: "Please contact our helpdesk for support at {email}",
		},
	},
	offerInformation: {
		calculating: "Your offer is being calculated...",
		calculatingHint: "Delivery costs and delivery dates are being determined with the manufacturing partners.",
		calculatingHint2: "With many items, this can take one to two minutes.",
		thanksForRequestTitle: "Thank you for your enquiry.",
		manualOfferRequestedText:
			"We have received your enquiry and will provide you with an order-specific offer. We ask for your patience while we process it. As soon as the offer is available, we will notify you by e-mail.",
		thanksForOrderTitle: "Thank you for your order.",
		orderedDirectlyText:
			"You can now view the status of the order in the order overview. You will also receive a confirmation e-mail shortly.",
		thanksForOrderTitle2: "Thank you for your order.",
		orderedIndirectlyText:
			"The responsible persons in your organisation will be informed of your order by e-mail shortly. These persons can adjust the order if necessary and then approve it. As soon as your order has been placed, you can view the status of the order in the order overview. You will also receive a confirmation e-mail then.",
		backToArticlesTooltip: "Navigates to the article catalogue.",
		backToArticles: "To my articles",
		offerSavedTitle: "Thank you for your enquiry.",
		offerSavedText: "Your offer PDF has been downloaded successfully.",
		offerSavedText2:
			"If you would like to accept our offer, please send us the PDF by e-mail to {email}.",
		offerSavedText3:
			"If you submit your order via an ERP or SAP system, we also ask you to attach the PDF document.",
		offerSavedText4: "This allows us to process your enquiry quickly and efficiently.",
		countryNotServiced: "Offer not possible",
		countryNotServicedText: "Unfortunately, we do not yet deliver to customers in your country.",
		countryNotServicedText2: "As soon as this changes, we will inform you via our newsletter.",
		noFertigerCanProduce:
			"Not all items in the cart can be produced at a single location,",
		noFertigerCanProduce2: "as raw materials and/or processing steps are mutually exclusive.",
		noFertigerCanProduce3:
			"As a rule, the order can be manufactured if the items are split accordingly.",
		noFertigerCanProduce4:
			"If you need support with this, click the button below to notify our helpdesk.",
		noFertigerHasDeliveryDate:
			"Due to high workload or a very high order quantity, no delivery dates could be found for your order.",
		noFertigerHasDeliveryDate2:
			"Click the button below if you would like to receive an offer for the requested quantity.",
		genericFailed: "The offer could not be created.",
		genericFailed2:
			"Unfortunately, an error occurred while creating your offer. Please try again.",
		genericFailed3: "If the error persists, please notify us using the button below.",
		notifyHelpdeskTooltip: "Notify Blexon helpdesk",
		notifyHelpdesk: "Notify helpdesk",
		offerValidPlural:
			"Your offers are valid for 15 minutes. Once this period has expired, you can start a recalculation.",
		offerValidSingular:
			"Your offer is valid for 15 minutes. Once this period has expired, you can start a recalculation.",
		recalculate: "Recalculate",
		helpdeskDialog: {
			title: "Notify Blexon helpdesk",
			text: "Our helpdesk will be informed about the situation and will get back to you as soon as possible at the following address.",
			emailLabel: "E-mail for notifications",
			cancelTooltip: "Cancel action",
			okButton: "Ok",
			okTooltip: "Notify helpdesk",
		},
		messages: {
			helpdeskInformed: "Helpdesk has been notified.",
			helpdeskInformError: "Helpdesk could not be notified.",
		},
	},
	delivery: {
		title: "Delivery method",
		question: "How would you like the sheet metal parts delivered?",
		producedBy: "Manufactured by: {name}",
		deliveryOption: "Delivered (1-2 days from delivery date)",
		rampeOption: "Ramp collection (unpacked)",
		fertigerLoadError: "The manufacturers could not be loaded.",
		selectionRequired: "Please select a location for ramp collection.",
		addressDialog: {
			title: "Address for ramp collection",
			phoneLabel: "Tel.:",
		},
		notPossibleDialog: {
			title: "Ramp collection not possible",
			text: "Unfortunately, collection of this order is not possible at this manufacturing partner. It may be that this manufacturing partner does not offer ramp collection, or that a material or processing step is not available.",
		},
	},
	summary: {
		chooseOffer: "Choose your offer",
		yourOffer: "Your offer",
	},
	manualOffer: {
		title: "{bold} Automated manufacturing & attractive volume discounts",
		titleBold: "Benefit now:",
		intro: "Your cart contains quantities and/or materials that entitle you to a {discount}.",
		discountHighlight: "volume discount",
		text2: "For larger quantities, material purchasing can be organised more efficiently and manufacturing can be automated {savings}",
		savingsHighlight: "– this significantly reduces costs!",
		text3: "Our manufacturing partner will review your request within 1–2 working days and provide you with an individual volume discount offer tailored to your requirements.",
		text4: "As a general rule: the more time you give us for production, the more attractive the volume discount.",
		callToAction: "Request an offer now and benefit!",
		chooseDeliveryDate: "Please select the latest delivery date (ex works).",
		deliveryDateLabel: "Latest delivery date",
		noDatesAvailable: "No delivery dates available",
		requestOfferTooltip: "Request offer",
		requestOffer: "Request offer",
		restrictionHint: "This option is only available for delivery or ramp collection in {town}.",
	},
};
